import { Chip, useTheme } from "@mui/material";
import React from "react";

interface Props {
  label: string;
  onClick?: () => void;
  focused: boolean;
  selected: boolean;
}

export const SteelGradeChip = ({
  label,
  onClick,
  selected,
  focused,
}: Props) => {
  const theme = useTheme();

  const sxProp = React.useMemo(() => {
    const baseSx = { userSelect: "none" };
    if (focused) {
      return {
        ...baseSx,
        backgroundColor: theme.palette.data.blue,
        color: theme.palette.common.white,
      };
    } else if (selected) {
      return {
        ...baseSx,
        backgroundColor: theme.palette.grey[600],
        color: theme.palette.common.white,
      };
    } else {
      return baseSx;
    }
  }, [focused, selected, theme]);

  return <Chip label={label} size="small" onClick={onClick} sx={sxProp} />;
};
